// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/20250410173632/js/" + chunkId + "." + {"453":"f3487ca5","766":"2d1d074f","772":"2d281ac1","941":"cf33175a"}[chunkId] + ".chunk.js";
};